exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app,.page-container,body,html{height:100%}.login-form{position:absolute;top:0;left:0;bottom:0;right:0;height:100%;width:100%;padding:0;margin:0;display:flex;align-items:center;justify-content:center;background-color:rgba(244,245,247,.47)}.login-form .login-wrap{border:1px solid #eaeefb;background-color:#fff;border-radius:4px;padding:40px 60px;text-align:center;transition:.2s}.login-form .login-wrap:hover{box-shadow:0 0 8px 0 rgba(232,237,250,.6),0 2px 4px 0 rgba(232,237,250,.5)}.login-form .login-wrap .el-form--label-top .el-form-item__label{padding:0}.login-form img{display:block;margin:0 auto}.login-form form{text-align:left}", ""]);

// exports
